/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarBasicDtoFromJSON, CarBasicDtoToJSON, } from './';
export function DeliverReturnHistoryResultFromJSON(json) {
    return DeliverReturnHistoryResultFromJSONTyped(json, false);
}
export function DeliverReturnHistoryResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'protocolNumber': !exists(json, 'protocolNumber') ? undefined : json['protocolNumber'],
        'car': !exists(json, 'car') ? undefined : CarBasicDtoFromJSON(json['car']),
        'accepted': !exists(json, 'accepted') ? undefined : (new Date(json['accepted'])),
        'isReturn': !exists(json, 'isReturn') ? undefined : json['isReturn'],
    };
}
export function DeliverReturnHistoryResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'protocolId': value.protocolId,
        'protocolNumber': value.protocolNumber,
        'car': CarBasicDtoToJSON(value.car),
        'accepted': value.accepted === undefined ? undefined : (value.accepted.toISOString()),
        'isReturn': value.isReturn,
    };
}
